<template>
  <div class="c-main-container">

    <div class="home_icon_area">

      <a href="https://summoners-saga.com/" class="icon" target="_blank"><img :src="icon+'/sum-saga_icon_144.png'"
                                                                              class="home-icon" alt="サマサガ"></a>

      <router-link :to="{name: 'WorksRemoteWorkLunch'}" class="icon"><img :src="icon+'/rwl_icon_144.png'"
                                                                          class="home-icon" alt="リモメシ">
      </router-link>
      <router-link :to="{name: 'WorksCREPOS'}" class="icon"><img :src="icon+'/crepos_icon_144.png'"
                                                                 class="home-icon" alt="CREPOS"></router-link>
      <router-link :to="{name: 'WorksKodomopay'}" class="icon"><img :src="icon+'/kodopay_icon_144.png'"
                                                                    class="home-icon" alt="こどもペイ"></router-link>
      <router-link :to="{name: 'WorksDogenzakaKobou'}" class="icon"><img :src="icon+'/d-kobou_icon.png'"
                                                                         class="home-icon" alt="道玄坂工房">
      </router-link>
      <router-link :to="{name: 'WorksHacot'}" class="icon"><img :src="icon+'/hacot_icon.png'" class="home-icon"
                                                                alt="ハコット">
      </router-link>
      <a href="https://www.afterfire.info" class="icon" target="_blank"><img :src="icon+'/AFRe_icon_144.png'"
                                                                             class="home-icon" alt="AFTER FIRE"></a>
      <router-link :to="{name: 'WorksZs3'}" class="icon"><img :src="icon+'/zero4_icon_144.png'" class="home-icon"
                                                              alt="ゼロヨンシフト"/>
      </router-link>
      <router-link :to="{name: 'WorksImHere2'}" class="icon"><img :src="icon+'/imhere2_icon_144.png'"
                                                                  class="home-icon" alt="いまここです〜 その2">
      </router-link>
      <router-link :to="{name: 'WorksEhonkan'}" class="icon"><img :src="icon+'/ehonkan_icon_144.png'"
                                                                  class="home-icon" alt="森のえほん館">
      </router-link>
      <router-link :to="{name: 'WorksPictbox'}" class="icon"><img :src="icon+'/pictbox_icon.png'" class="home-icon"
                                                                  alt="PICTBOX">
      </router-link>
      <router-link :to="{name: 'WorksRide2victory'}" class="icon"><img :src="icon+'/ride2victory_icon_144.png'"
                                                                       class="home-icon" alt="打蹴投極">
      </router-link>
      <router-link :to="{name: 'WorksImHere'}" class="icon"><img :src="icon+'/imhere_icon_144.png'" class="home-icon"
                                                                 alt="いまここです〜">
      </router-link>
      <router-link :to="{name: 'WorksIshiiSan'}" class="icon"><img :src="icon+'/ishii_san_icon_144.png'"
                                                                   class="home-icon" alt="なにわの石井さん">
      </router-link>
      <router-link :to="{name: 'WorksChelsea'}" class="icon"><img :src="icon+'/chelsea_icon_144.png'"
                                                                  class="home-icon" alt="チェルシーのドーナツ工場">
      </router-link>
      <router-link :to="{name: 'WorksHaniwan'}" class="icon"><img :src="icon+'/haniwan_icon_144.png'"
                                                                  class="home-icon" alt="はにわん">
      </router-link>
      <router-link :to="{name: 'WorksCalorina'}" class="icon"><img :src="icon+'/calorina_icon_144.png'"
                                                                   class="home-icon" alt="カロリナ">
      </router-link>
      <router-link :to="{name: 'WorksAkari'}" class="icon"><img :src="icon+'/akarichan_icon_144.png'"
                                                                class="home-icon" alt="とまとのあかりちゃん">
      </router-link>
      <a href="https://blog.a4works.co.jp/" class="icon"><img :src="icon+'/blog.a4works_icon_144.png'"
                                                              class="home-icon" alt="A4WORKS Blog"></a>
    </div>

    <div class="m40"></div>

    <hr class="c-hr-contents-area">

    <h2 class="c-default">お知らせ</h2>

    <Information :isHome="true"/>

  </div>
</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import Information from '@/components/common/Information'

export default {
  components: {
    Header,
    Footer,
    Information
  },
  data () {
    return {
      icon: '/static/images/app_icon'
    }
  }
}

</script>

<style lang="scss" scoped>

.home_icon_area {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
}

// 801以上
@media screen and (min-width: 801px) {
  .home-icon {
    width: 144px;
    margin: 3px;
  }
}

// 800まで
@media screen and (max-width: 800px) {
  .icon {
    width: 22%;
    margin: 4px;
  }
  .home-icon {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/001_Home.vue